'use strict';

const { disableBodyScroll, clearAllBodyScrollLocks } = require("../thirdParty/bodyScrollLock");

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    //Reinit Filter Search after Ajax call
    initAllSearchFilters();

    $('.refinements .collapse').on('shown.bs.collapse', function () {
        $(this).parent().addClass('active');
        if(window.innerWidth > 767) {
            $(document.body).trigger("sticky_kit:recalc");
        }
    });

    $('.refinements .collapse').on('hidden.bs.collapse', function () {
        $(this).parent().removeClass('active');
    });
}

/**
 * Init All Search Filters
 */
function initAllSearchFilters() {
    // ILB-225 - filter search
    if($('.refinements').length) {
        var refinements = $('#client-side-search-refinements').val().split(',')

        refinements.forEach(function (refinementKey) {
            initFilterSearch(refinementKey);
        });
    }
}

/**
 * Init Filter Search
 */
function initFilterSearch(refinementKey) {
    //Show Search Bar
    if ($("#" + refinementKey + "-search").length > 0) {
        $("#" + refinementKey + "-search").show();
        //Activate Search Bar
        $(document).on('propertychange input',"#" + refinementKey + "-keyword", function(e) {
            var $this = $(this);
            var exp = new RegExp($this.val(), 'i');
            $("#refinement-" + refinementKey + " button div.search-key").each(function() {
                var $self = $(this);
                if(!exp.test($self.text())) {
                    $self.closest('li').hide();
                } else {
                    $self.closest('li').show();
                }
            });
        });
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    if(!$('.refinement-brand').hasClass('active')) {
        $results.find('.refinement-brand').removeClass('active');
    }
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
        activeDiv.find('.content.collapse').addClass('show');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.result-count'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
    $(document.body).trigger("sticky_kit:recalc");
    $('.refinement-bar').trigger("sticky_kit:unbottom");
}

/**
 * Update browser URL if enabled.
 * @param {string} response - Ajax response HTML code
 * @param {string} updateBrowserUrl - Flag indicating if browser url should be updated
 * @returns
 */
function updateBrowserUrl(response, updateBrowserUrl) {
	if (true === updateBrowserUrl) {
		var permaLink = $(response).find('.permalink').val();
		if (typeof permaLink !== "undefined") {
			history.pushState(undefined, '', permaLink);
		}
	}
}

function lockbodyscroll(el) {
    console.log('body locked');
    $('body').addClass('locked');
    disableBodyScroll(el);
}

function clearbodyscroll() {
    console.log('body lock cleared');
    $('body').removeClass('locked');
    clearAllBodyScrollLocks();
}

function observerCallback (entries, observer) {
    // Empty object where we can store current item's index before drag

    entries.forEach(entry => {
        if(entry.isIntersecting){
            var $img = $(entry.target).closest('.image-link').find('.tile-image-2 img')
            if($img.length && !$img.hasClass('intersected')) {
                lazySizes.loader.unveil($img[0])
                $img.addClass('intersected');
            }
        }
    });


};

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.filter-container').off('click', 'button.filter-results');
        $('.filter-container').on('click', 'button.filter-results', function (e) {
            e.stopPropagation();
            if(window.innerWidth < 768) {
                $('.refinement-bar, .modal-background').show();
                $('.refinement-bar').siblings().attr('aria-hidden', true);
                $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
                $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
                $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
                
                // Closing initial open tabs for mobile devices.
                if ($('.refinements .collapse.show')) {
                    $('.refinements .collapse.show').parent().removeClass('active');
                    $('.refinements .collapse.show').removeClass('show');
                }

                // $('.refinement-bar .close').focus();
                lockbodyscroll(document.querySelector('.refinements'));
            } else {
                if(!$('.refinement-bar').hasClass('refinement-collapsed')) {
                    $('.refinement-bar').addClass('refinement-collapsed');
                    $('.filter-bar .filter-results').removeClass('d-md-none');
                    // $('.refinement-bar').next().removeClass('col-md-9');
                } else {
                    $('.refinement-bar').removeClass('refinement-collapsed');
                    $('.filter-bar .filter-results').addClass('d-md-none');
                    // $('.refinement-bar').next().addClass('col-md-9');
                }
            }
        });

        $('.refinements .collapse').on('shown.bs.collapse', function () {
            $(this).parent().addClass('active');
            if(window.innerWidth > 767) {
                $(document.body).trigger("sticky_kit:recalc");
            }
        });

        $('.refinements .collapse').on('hidden.bs.collapse', function () {
            $(this).parent().removeClass('active');
        });

        $('body').on('click', function (e) {
            if($('.refinements .collapse.show').length && (!$(e.target).hasClass('refinement') && !$(e.target).closest('.refinement').length)){
                $('.refinements .collapse.show').collapse('hide');
            }
        })

        if(window.innerWidth > 767) {
            if($('.filter-container').length) {
                $('.filter-container').stick_in_parent();
            }
        } else {
            $('.filter-bar').stick_in_parent();
        }
    },

    closeRefinements: function () {
        // Refinements close button
        $('.filter-container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            // $('.btn.filter-results').focus();
            clearbodyscroll();
        });
    },

    // resize: function () {
    //     // Close refinement bar and hide modal background if user resizes browser
    //     $(window).resize(function () {
    //         $('.refinement-bar, .modal-background').hide();
    //         $('.refinement-bar').siblings().attr('aria-hidden', false);
    //         $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
    //         $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    //         $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
    //     });
    // },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    //$('.product-grid').empty().html(response);
                    parseResults(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $('.sort-order-dropdown').find('.dropdown-toggle').html($('.sort-order-dropdown .active').html());
        $(document).on('click',  '.sort-order-dropdown .dropdown-item',function(e) {
            e.preventDefault();

            $(this).parents('.sort-order-dropdown').find('.dropdown-toggle').html($(this).html());
            $(this).parents('.sort-order-dropdown').find('.dropdown-toggle').trigger('mouseleave');
            $(this).parents(".sort-order-dropdown").find(".dropdown-toggle").attr('aria-label', $(this).attr('aria-label'));
            $.spinner().start();
            $('select[name=sort-order]').trigger('search:sort', this.href);

            //set browser history

            const paramsString = window.location.search;
            const searchParams = new URLSearchParams(paramsString);
            searchParams.set('srule', $(this).attr('data-id'));
            var url = window.location.href.split('?')[0] + '?' + searchParams.toString();
            if (url && url.length > 0) {
                history.pushState(undefined, '', url);
            }
            $.ajax({
                url: url,
                data: { selectedUrl: url },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    if($('.refinement-bar').hasClass('refinement-collapsed')) {
                        $('.filter-bar .filter-results').removeClass('d-md-none');
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            e.preventDefault();
            
            var showMoreUrl = $(this).data('url');
            var updateBrowserUrlFlag = $(this).data('updatebrowserurl');
            
            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $('.refinement-bar').trigger("sticky_kit:unbottom");
            $('.refinement-bar').css('bottom', '');

            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
					updateBrowserUrl(response, updateBrowserUrlFlag);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $this = $(this);

                $.spinner().start();
                $this.trigger('search:filter', e);
                
                //set browser history
                var origUrl = $this.data('href-orig');
                if (origUrl && origUrl.length > 0) {
                	history.pushState(undefined, '', origUrl);
                }

                if ($this.hasClass('reset')) {
                    // Closing initial open tabs for mobile devices.
                    if ($('.refinements .collapse.show')) {
                        $('.refinements .collapse.show').parent().removeClass('active');
                        $('.refinements .collapse.show').removeClass('show');
                    }
                }
                
                $.ajax({
                    url: $this.data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $this.data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        if($('.refinement-bar').hasClass('refinement-collapsed')) {
                            $('.filter-bar .filter-results').removeClass('d-md-none');
                        }

                        if (window.innerWidth < 768) { 
                            // Closing initial open tabs for mobile devices.
                            if ($('.refinements .collapse.show')) {
                                if (!$('.refinements .collapse.show').parent().hasClass('active')) {
                                    $('.refinements .collapse.show').parent().removeClass('active');
                                    $('.refinements .collapse.show').removeClass('show');
                                }
                            }
                        }

                        // Fixing an issue with +/- icon not matching.
                        $('.refinements .collapse.show').each( function(idx, element) {
                            if(!$this.parent().hasClass('active')) {
                                $this.removeClass('show');
                            }
                        })
                        $('body').trigger('trigger:accBorder',[$('.search-key:contains("'+$this.find(".search-key").text()+'")').parent(), 0]);
                        
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    filterSearch: function () {
        // ILB-225 - filter search
        initAllSearchFilters();
    },

    initStickyBrandNav: function() {
        $('.brands-scrollspy .brands-navbar').stick_in_parent();
        if(window.innerWidth > 768) {
            $('body').scrollspy({ target: '#brands-nav', offset: 126 });
        } else {
            $('body').scrollspy({ target: '#brands-nav', offset: 1 });
        }
        $('.brand-overview').on('click', '.nav-link', function(e){
            if(window.innerWidth > 768) {
                var target = $(this.hash);
                e.preventDefault();
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 125 //offsets for fixed header
                    }, 0);
                    return false;
                }
            }
        });
    },

    searchPOS: function() {
        $('#simpleSearchOrder').submit(function(e){
            e.preventDefault();

            var url = $(this).attr('action');

            var newForm = $(this).serialize();

            $.ajax({
                url: url,
                method: 'post',
                dataType: 'json',
                data: newForm,
                success: function (data) {

                    $('.order-manage-list').children().remove();
                    $('.order-list .no-results-msg').remove();

                    if(!data.number){
                        $('.order-manage-list').parent().prepend('<p class="no-results-msg">'+data.zeroResults+'</p>');
                    }
                    else{
                        $('.order-manage-list').append('<h3 class="order-no">'+data.number+'</h3>')
                        $('.order-manage-list').append('<div class="customer-name"><b>'+ $('.order-manage-list').data('name')+'</b> '+data.name+'</div>')
                        $('.order-manage-list').append('<div class="nav-id"><b>'+ $('.order-manage-list').data('nav')+'</b> '+data.navID+'</div>')
                        $('.order-manage-list').append('<div class="customer-phone"><b>'+ $('.order-manage-list').data('phone')+'</b> '+data.phone+'</div>')
                        $('.order-manage-list').append('<h6 class="order-lines">'+ $('.order-manage-list').data('orderlines')+'</h6>')

                        for (let i = 0; i < data.orderDetails.length; i++) {
                            var detail = data.orderDetails[i];

                            $('.order-manage-list').append('<div class="product-info-'+i+'"></div')
                            
                            $('.order-manage-list .product-info-'+i).append('<div class="product-name"><b>'+ $('.order-manage-list').data('productname')+'</b> '+detail.name+'</div>')
                            $('.order-manage-list .product-info-'+i).append('<div class="product-id"><b>'+ $('.order-manage-list').data('id')+'</b> '+detail.ID+'</div>')
                            $('.order-manage-list .product-info-'+i).append('<div class="product-price"><b>'+ $('.order-manage-list').data('price')+'</b> '+detail.price+'</div>')
                            if(detail.discount){
                                $('.order-manage-list .product-info-'+i).append('<div class="product-discount"><b>'+ $('.order-manage-list').data('discount')+'</b> '+detail.discount+'</div>')
                            }
                            $('.order-manage-list .product-info-'+i).append('<div class="product-quantity"><b>'+ $('.order-manage-list').data('quantity')+'</b> '+detail.quantity+'</div>')
                            $('.order-manage-list .product-info-'+i).append('<div class="product-total"><b>'+ $('.order-manage-list').data('total')+'</b> '+detail.total+'</div>')
                            
                        }

                        $('.order-manage-list').append('<h6 class="order-lines">'+ $('.order-manage-list').data('ordertotaltext')+'</h6>')
                        $('.order-manage-list').append('<div class="order-total"><b>'+ $('.order-manage-list').data('ordertotal')+'</b> '+data.total+'</div>')
                        
                        for(var i =0; i<data.paymentMethods.length; i++){
                            $('.order-manage-list').append('<div class="payment-instrument"><b>'+ data.paymentMethodText+'</b> '+data.paymentMethods[i].paymentMethod+'</div>');
                            if(data.paymentMethods.length > 1){
                                $('.order-manage-list').append('<div class="payment-amount"><b>'+ data.amountText+'</b>: '+data.paymentMethods[i].amount+'</div>');
                            }
                            if(data.paymentMethods[i].giftcert){
                                $('.order-manage-list').append('<div class="bonus-check"><b>'+ data.paymentMethods[i].bonusCheckText+'</b> '+data.paymentMethods[i].bonusCheck+'</div>');
                            }
                        }
                    }

                },
                error: function () {
                    $('.gift-registry-manage-list').children().remove();
                    $.spinner().stop();
                }
            });

        });
    },

    closeFilter: function() {
        $(document).on('keyup', '.card-body', function (e) {
            console.log('test ' + e.key);
            if(e.key == 'Escape'){
                $(this).collapse('hide');
                $('body').trigger('trigger:accBorder',[$(this).parent().find('.text-left'), 0,]);
                
            }
        })

        $(document).on('keyup', '.sort-order-dropdown .dropdown-menu', function (e) {
            console.log('test ' + e.key);
            if(e.key == 'Escape'){
                $(this).collapse('hide');
                $('body').trigger('trigger:accBorder',[$(this).parent().find('.dropdown-toggle'), 0]);
                
            }
        })
    }
};